import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import storage from '@/util/storage.js'
import apis from '@/api/index.js'

import common from "@/util/common";

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI);

Vue.prototype.$http = apis.http		// 网络请求
Vue.prototype.$Api = apis.ServerUrl 	// 服务端地址

Vue.prototype.$storage = storage
Vue.prototype.$common = common

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
